/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { EmailPlaceholder } from 'utils/email/useEmailPlaceholders'

interface EmailTemplatePlaceholderItemProps {
    placeholder: EmailPlaceholder
    onClick: (key: string) => void
}

const EmailTemplatePlaceholderItem: React.FC<EmailTemplatePlaceholderItemProps> = ({ placeholder, onClick }) => {
    const { t } = useTranslation()

    const hasValue = placeholder.value !== null && placeholder.value !== undefined && placeholder.value !== ''

    return (
        <code
            className="EmailTemplatePlaceholderItem text-[10px] px-2 py-1 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded cursor-pointer hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:border-blue-300 dark:hover:border-blue-700 transition-colors flex items-center gap-1"
            onClick={() => onClick(placeholder.key)}
            title={placeholder.key}
        >
            <span className="font-semibold text-gray-700 dark:text-gray-300">{placeholder.label}:</span>
            <span
                className={clsx(
                    'max-w-[120px] truncate',
                    hasValue ? 'text-gray-500 dark:text-gray-400' : 'text-red-500 dark:text-red-400 font-medium'
                )}
            >
                {hasValue ? placeholder.value : t('N/A')}
            </span>
        </code>
    )
}

export default EmailTemplatePlaceholderItem
